/**
 * Farbfilter-Vorbelegung einer Kartensuche aus den Commander-Karten des Decks — geteilt
 * vom mobilen Hinzufügen-Modus und dem Suche-Reiter des Katalogs.
 *
 * „Farblos" (C) MUSS dabei sein: Mit C in der Auswahl bedeutet der Farbfilter
 * „Farbidentität ist Teilmenge der gewählten Farben" — die Commander-Regel. Ohne C
 * bedeutet dieselbe Auswahl „genau diese Farben", und einfarbig rote Karten fielen aus
 * einem Rot-Grün-Deck heraus. Ein einzelnes C trifft „Farbidentität leer".
 *
 * Ohne Commander (oder bei leerem Deck) bleibt der Filter leer — dann zeigt die Suche
 * ihren Hinweis, statt willkürliche Karten anzubieten.
 */
export function commanderColorFilter(cards) {
  const commanders = (cards || []).filter((c) => c.isCommander);
  if (commanders.length === 0) return [];
  const farben = new Set();
  commanders.forEach((c) => (c.colorIdentity || []).forEach((f) => farben.add(f)));
  farben.add('C');
  return [...farben];
}
